import shaka from 'shaka-player';
import YouboraAdapterShaka from 'youbora-adapter-shaka';
import defaults from 'lodash/defaults';
import { completeWithDefaults, getPlayerVersion } from './utils.js';
import 'lodash/mapValues';

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const { util: { Error: ShakaError } } = shaka;
class NpawAdapterShaka extends YouboraAdapterShaka {
  constructor(player, tag, options = {}) {
    super(player, tag);
    __publicField(this, "getPlayerVersion", getPlayerVersion);
    this.options = completeWithDefaults(options);
    this.hasFatalError = false;
    this.assetUri = void 0;
    this.ignoreUnloadingStop = false;
  }
  setOptions(options) {
    const mergedOptions = defaults({}, options, this.options);
    this.options = completeWithDefaults(mergedOptions);
  }
  setAssetUri(assetUri) {
    this.assetUri = assetUri;
  }
  setIgnoreUnloadingStop(ignoreUnloadingStop) {
    this.ignoreUnloadingStop = ignoreUnloadingStop;
  }
  getResource() {
    return this.player.getAssetUri() || this.assetUri || void 0;
  }
  registerListeners() {
    super.registerListeners();
    this.dtvgoPlayerListeners = {
      loading: this.loadingListener.bind(this),
      unloading: this.unloadingListener.bind(this),
      loaded: this.loadedListener.bind(this)
    };
    for (const [key, listener] of Object.entries(this.dtvgoPlayerListeners)) {
      this.player.addEventListener(key, listener);
    }
  }
  unregisterListeners() {
    super.unregisterListeners();
    for (const [key, listener] of Object.entries(this.dtvgoPlayerListeners)) {
      this.player.removeEventListener(key, listener);
    }
  }
  loadingListener() {
    this.hasFatalError = false;
    this.isEnded = false;
    this.setIgnoreUnloadingStop(true);
    if (this.options.disableInitOnLoading)
      return;
    this.fireInit({}, "loadingListener");
  }
  loadedListener() {
    this.setIgnoreUnloadingStop(false);
  }
  unloadingListener() {
    this.isEnded = true;
    this.setAssetUri(void 0);
    if (this.ignoreUnloadingStop)
      return;
    this.fireStop({}, "unloadingListener");
  }
  /**
   * @param {shaka.extern.Error} error
   */
  onLoadFailed(error) {
    if (error.code !== ShakaError.Code.LOAD_INTERRUPTED || this.options.reportLoadInterruptedError)
      this.reportError(error, "onLoadFailed");
    this.setIgnoreUnloadingStop(false);
  }
  errorListener(errorEvent) {
    const error = errorEvent?.detail;
    this.reportError(error, "errorListener");
  }
  reportError(error, source) {
    if (this.hasFatalError || this.options.errorCodesToAvoid.includes(error.code))
      return;
    const { name, description, metadata } = this.options.errorParser(error);
    const details = metadata || this.options.getErrorDetails(error);
    const isFatal = !error.handled && !error.ignored && (error.severity === ShakaError.Severity.CRITICAL && !this.options.nonFatalErrorCodes.includes(error.code) || error.severity === ShakaError.Severity.RECOVERABLE && this.options.fatalErrorCodes.includes(error.code));
    if (isFatal) {
      this.hasFatalError = true;
      this.fireFatalError(name, description, details, "fatal", source);
    } else {
      this.fireError(name, description, details, "error", source);
    }
    this.setIgnoreUnloadingStop(false);
  }
  timeupdateListener(...args) {
    if (this.isEnded)
      return;
    super.timeupdateListener(...args);
  }
  getVersion() {
    const baseAdapterVersion = super.getVersion();
    return `${baseAdapterVersion}:dtvgo-${"2.0.1"}`;
  }
  dispose() {
    if (this.isDisposed)
      return;
    super.dispose();
    this.isDisposed = true;
  }
}

export { NpawAdapterShaka as default };
//# sourceMappingURL=NpawAdapterShaka.js.map
